import React from 'react'
import { withStyles } from 'material-ui/styles'
import Table, {TableBody, TableCell, TableHead, TableRow} from 'material-ui/Table'
import PropTypes from 'prop-types'
import IconButton from 'material-ui/IconButton'
import PictureAsPdfIcon from 'material-ui-icons/PictureAsPdf'
import moment from 'moment'

const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 200
  },
  button: {
    margin: theme.spacing.unit
  }
})

const Invoices = props => {
  const { classes, invoices } = props

  return (
    <div className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Stop</TableCell>
            <TableCell>Client</TableCell>
            <TableCell>Products</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Pending</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Created At</TableCell>
            <TableCell>Invoice</TableCell>
            <TableCell>Delivery note</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoices.map(invoice => (
            <TableRow key={invoice._id}>
              <TableCell>{invoice.invoiceNumber}</TableCell>
              <TableCell>{invoice.client.location}</TableCell>
              <TableCell>{invoice.client.name}</TableCell>
              <TableCell>{invoice.items.length}</TableCell>
              <TableCell>{invoice.sales}</TableCell>
              <TableCell>{invoice.pendingAmount}</TableCell>
              <TableCell>{invoice.status}</TableCell>
              <TableCell>{moment(invoice.period.from).format('DD-MMM-YYYY')}</TableCell>
              <TableCell>
                {invoice.pdf && <a href={invoice.pdf}><IconButton className={classes.button} aria-label='pdf'>
                  <PictureAsPdfIcon />
                </IconButton></a>}
              </TableCell>
              <TableCell>
                <a href={invoice.deliveryPdfUrl}><IconButton className={classes.button} aria-label='pdf'>
                  <PictureAsPdfIcon />
                </IconButton></a>
              </TableCell>
            </TableRow>)
          )}
        </TableBody>
      </Table>
    </div>
  )
}

Invoices.defaultProps = {
  invoices: []
}

Invoices.propTypes = {
  invoices: PropTypes.array.isRequired
}

export default withStyles(styles)(Invoices)



// WEBPACK FOOTER //
// ./src/jobs/Invoices.js